(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[12312],{

/***/ 27554:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/[template_slug]",
      function () {
        return __webpack_require__(73949);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Alert(param) {
    var children = param.children, className = param.className, type = param.type, open = param.open, setOpen = param.setOpen;
    var typeIcon = function(type) {
        switch(type){
            case "warning":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z"
                    })
                });
            case "error":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z"
                    })
                });
            case "success":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z"
                    })
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
                    })
                });
        }
    };
    var typeColor = function(type) {
        switch(type){
            case "warning":
                return "bg-yellow-100 border-yellow-200 text-yellow-600";
            case "error":
                return "bg-red-100 border-red-200 text-red-600";
            case "success":
                return "bg-green-100 border-green-200 text-green-600";
            default:
                return "bg-indigo-100 border-indigo-200 text-indigo-500";
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (open) {
            var timer = setTimeout(function() {
                setOpen(false);
            }, 2500);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-4 py-2 rounded-sm text-sm border ".concat(typeColor(type)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full justify-between items-start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex",
                            children: [
                                typeIcon(type),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: children
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: "opacity-70 hover:opacity-80 ml-3 mt-[3px]",
                            onClick: function() {
                                return setOpen(false);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "sr-only",
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "w-4 h-4 fill-current",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Alert);


/***/ }),

/***/ 86707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Button_loading = function(param) {
    var text_color = param.text_color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: "animate-spin -ml-1 mr-3 h-5 w-5 ".concat(text_color),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button_loading);


/***/ }),

/***/ 33615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_Transition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1193);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73935);






function Sidepan(param) {
    var children = param.children, id = param.id, sidepanOpen = param.sidepanOpen, setSidepanOpen = param.setSidepanOpen, justify_align = param.justify_align, closeByOutsideClick = param.closeByOutsideClick, closeByEscClick = param.closeByEscClick, sidepan_component_styles = param.sidepan_component_styles, custom_content_box_styles = param.custom_content_box_styles, hide_back_shadow = param.hide_back_shadow, fixed_main_width = param.fixed_main_width;
    var modalContent = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        setMounted(true);
    }, []);
    // close on click outside
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (closeByOutsideClick) {
            var clickHandler = function(param) {
                var target = param.target;
                var ref;
                if (!sidepanOpen || modalContent.current.contains(target) || (target === null || target === void 0 ? void 0 : (ref = target.id) === null || ref === void 0 ? void 0 : ref.includes("react-select"))) return;
                setSidepanOpen(false);
            };
            document.addEventListener("click", clickHandler);
            return function() {
                return document.removeEventListener("click", clickHandler);
            };
        }
    });
    // close if the esc key is pressed
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (closeByOutsideClick || closeByEscClick) {
            var keyHandler = function(param) {
                var keyCode = param.keyCode;
                if (!sidepanOpen || keyCode !== 27) return;
                setSidepanOpen(false);
            };
            document.addEventListener("keydown", keyHandler);
            return function() {
                return document.removeEventListener("keydown", keyHandler);
            };
        }
    });
    // Return null during SSR
    if (!mounted) return null;
    // Only create portal on client-side
    var portalElement =  true ? document.body : 0;
    if (!portalElement) return null;
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_5__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            hide_back_shadow !== true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_Transition__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                className: "fixed inset-0 bg-gray-900 bg-opacity-30 z-100 transition-opacity",
                show: sidepanOpen,
                enter: "transition ease-out duration-200",
                enterStart: "opacity-0",
                enterEnd: "opacity-100",
                leave: "transition ease-out duration-100",
                leaveStart: "opacity-100",
                leaveEnd: "opacity-0",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_Transition__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                id: id,
                className: [
                    "fixed inset-0 z-100  overflow-hidden flex items-center    transform ",
                    justify_align ? "justify-".concat(justify_align) : "justify-end",
                    fixed_main_width ? fixed_main_width : "w-auto", 
                ].join(" "),
                role: "dialog",
                "aria-modal": "true",
                show: sidepanOpen,
                enter: "transition ease-in-out duration-200",
                enterStart: "opacity-0 translate-y-4",
                enterEnd: "opacity-100 translate-y-0",
                leave: "transition ease-in-out duration-200",
                leaveStart: "opacity-100 translate-y-0",
                leaveEnd: "opacity-0 translate-y-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: modalContent,
                    className: [
                        "bg-white   shadow-lg overflow-auto  rounded-md  max-h-full  ",
                        sidepan_component_styles !== null && sidepan_component_styles !== void 0 ? sidepan_component_styles : "",
                        custom_content_box_styles, 
                    ].join(" "),
                    children: children
                })
            })
        ]
    }), portalElement);
}
/* harmony default export */ __webpack_exports__["Z"] = (Sidepan);


/***/ }),

/***/ 25470:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Google = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-wrap -mx-3",
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-full px-3",
            children: /*#__PURE__*/ _jsxs("button", {
                className: "btn px-0 text-white bg-red-600 hover:bg-red-700 w-full relative flex items-center",
                children: [
                    /*#__PURE__*/ _jsx("svg", {
                        className: "w-4 h-4 fill-current text-white opacity-75 flex-shrink-0 mx-4",
                        viewBox: "0 0 16 16",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ _jsx("path", {
                            d: "M7.9 7v2.4H12c-.2 1-1.2 3-4 3-2.4 0-4.3-2-4.3-4.4 0-2.4 2-4.4 4.3-4.4 1.4 0 2.3.6 2.8 1.1l1.9-1.8C11.5 1.7 9.9 1 8 1 4.1 1 1 4.1 1 8s3.1 7 7 7c4 0 6.7-2.8 6.7-6.8 0-.5 0-.8-.1-1.2H7.9z"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "flex-auto pl-16 pr-8 -ml-16",
                        children: "Continue with Google"
                    })
                ]
            })
        })
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Google)));


/***/ }),

/***/ 81310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L2": function() { return /* binding */ set_selected_tenant_configs; },
/* harmony export */   "pb": function() { return /* binding */ set_all_sites; },
/* harmony export */   "wV": function() { return /* binding */ set_all_tenant_configs; },
/* harmony export */   "x6": function() { return /* binding */ select_domain; },
/* harmony export */   "xm": function() { return /* binding */ set_editor_preview_size; }
/* harmony export */ });
/* unused harmony exports set_all_draft_configs, set_selected_draft_configs, set_dynamic_pages */
/* harmony import */ var _actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13047);

var select_domain = function(data) {
    return {
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SELECTED_SITE */ .t9,
        payload: data
    };
};
//
var set_all_sites = function(data) {
    return {
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .ALL_SITES */ .PJ,
        payload: data
    };
};
//
var set_all_tenant_configs = function(data) {
    return {
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .TENANT_CONFIGS */ .pF,
        payload: data
    };
};
//
var set_all_draft_configs = function(data) {
    return {
        type: DRAFT_CONFIGS,
        payload: data
    };
};
//
var set_selected_tenant_configs = function(data) {
    return {
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SELECTED_TENANT_CONFIGS */ .e4,
        payload: data
    };
};
//
var set_selected_draft_configs = function(data) {
    return {
        type: SELECTED_DRAFT_CONFIGS,
        payload: data
    };
};
//
var set_editor_preview_size = function(data) {
    return {
        type: _actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SELECTED_EDITIOR_PREVIEW_SIZE */ .lh,
        payload: data
    };
};
//
var set_dynamic_pages = function(data) {
    return {
        type: ALL_DYNAMIC_PAGES,
        payload: data
    };
};


/***/ }),

/***/ 73949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _partials_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86518);
/* harmony import */ var _partials_FooterOLD2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93781);
/* harmony import */ var _partials_TutorialsList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45497);
/* harmony import */ var _partials_Newsletter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46521);
/* harmony import */ var _partials_YoutubeTutorialsList__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87218);
/* harmony import */ var _components_Templates_Index_TemplaeNewsletter__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91257);
/* harmony import */ var _components_Templates_Index_TemaplatesList__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72457);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_Templates_Details_TemplatesDetails__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61576);
/* harmony import */ var _api_api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10107);
/* harmony import */ var constant_functions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(60538);
/* harmony import */ var _WebHandler_api_call__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(24236);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _img_tradly_Tradly_MEta_image_png__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(52066);
/* harmony import */ var _partials_TradlyFooter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48777);
/* harmony import */ var _context_store_AppContext__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21219);
/* harmony import */ var _context_store_actions__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81310);




















function TemplateDetails(param) {
    var user_details = param.user_details, tenant_details = param.tenant_details, template_details = param.template_details, sites_list = param.sites_list;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    // context
    var ref27 = (0,_context_store_AppContext__WEBPACK_IMPORTED_MODULE_17__/* .useAppContext */ .b)(), state = ref27.state, dispatch = ref27.dispatch;
    // workspaces
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (sites_list && (sites_list === null || sites_list === void 0 ? void 0 : sites_list.length) > 0) {
            dispatch((0,_context_store_actions__WEBPACK_IMPORTED_MODULE_18__/* .select_domain */ .x6)(sites_list[0]));
            dispatch((0,_context_store_actions__WEBPACK_IMPORTED_MODULE_18__/* .set_all_sites */ .pb)(sites_list));
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: (template_details === null || template_details === void 0 ? void 0 : (ref = template_details.listing) === null || ref === void 0 ? void 0 : ref.meta_title) ? template_details === null || template_details === void 0 ? void 0 : (ref1 = template_details.listing) === null || ref1 === void 0 ? void 0 : ref1.meta_title : template_details === null || template_details === void 0 ? void 0 : (ref2 = template_details.listing) === null || ref2 === void 0 ? void 0 : ref2.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: (template_details === null || template_details === void 0 ? void 0 : (ref3 = template_details.listing) === null || ref3 === void 0 ? void 0 : ref3.meta_description) ? template_details === null || template_details === void 0 ? void 0 : (ref4 = template_details.listing) === null || ref4 === void 0 ? void 0 : ref4.meta_description : template_details === null || template_details === void 0 ? void 0 : (ref5 = template_details.listing) === null || ref5 === void 0 ? void 0 : ref5.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: (template_details === null || template_details === void 0 ? void 0 : (ref6 = template_details.listing) === null || ref6 === void 0 ? void 0 : ref6.meta_keyword) ? template_details === null || template_details === void 0 ? void 0 : (ref7 = template_details.listing) === null || ref7 === void 0 ? void 0 : ref7.meta_keyword : template_details === null || template_details === void 0 ? void 0 : (ref8 = template_details.listing) === null || ref8 === void 0 ? void 0 : ref8.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: (template_details === null || template_details === void 0 ? void 0 : (ref9 = template_details.listing) === null || ref9 === void 0 ? void 0 : ref9.meta_title) ? template_details === null || template_details === void 0 ? void 0 : (ref10 = template_details.listing) === null || ref10 === void 0 ? void 0 : ref10.meta_title : template_details === null || template_details === void 0 ? void 0 : (ref11 = template_details.listing) === null || ref11 === void 0 ? void 0 : ref11.title
                    }, "title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "".concat((template_details === null || template_details === void 0 ? void 0 : (ref12 = template_details.listing) === null || ref12 === void 0 ? void 0 : ref12.meta_title) ? template_details === null || template_details === void 0 ? void 0 : (ref13 = template_details.listing) === null || ref13 === void 0 ? void 0 : ref13.meta_title : template_details === null || template_details === void 0 ? void 0 : (ref14 = template_details.listing) === null || ref14 === void 0 ? void 0 : ref14.title)
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: (template_details === null || template_details === void 0 ? void 0 : (ref15 = template_details.listing) === null || ref15 === void 0 ? void 0 : ref15.meta_description) ? template_details === null || template_details === void 0 ? void 0 : (ref16 = template_details.listing) === null || ref16 === void 0 ? void 0 : ref16.meta_description : template_details === null || template_details === void 0 ? void 0 : (ref17 = template_details.listing) === null || ref17 === void 0 ? void 0 : ref17.description
                    }, "twitter:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: (template_details === null || template_details === void 0 ? void 0 : (ref18 = template_details.listing) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.images) === null || ref19 === void 0 ? void 0 : ref19.length) > 0 ? template_details === null || template_details === void 0 ? void 0 : (ref20 = template_details.listing) === null || ref20 === void 0 ? void 0 : ref20.images[0] : "https://tradly.app".concat(_img_tradly_Tradly_MEta_image_png__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)
                    }, "twitter:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }, "og:type"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: (template_details === null || template_details === void 0 ? void 0 : (ref21 = template_details.listing) === null || ref21 === void 0 ? void 0 : ref21.meta_description) ? template_details === null || template_details === void 0 ? void 0 : (ref22 = template_details.listing) === null || ref22 === void 0 ? void 0 : ref22.meta_description : template_details === null || template_details === void 0 ? void 0 : (ref23 = template_details.listing) === null || ref23 === void 0 ? void 0 : ref23.description
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: (template_details === null || template_details === void 0 ? void 0 : (ref24 = template_details.listing) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.images) === null || ref25 === void 0 ? void 0 : ref25.length) > 0 ? template_details === null || template_details === void 0 ? void 0 : (ref26 = template_details.listing) === null || ref26 === void 0 ? void 0 : ref26.images[0] : "https://tradly.app".concat(_img_tradly_Tradly_MEta_image_png__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)
                    }, "og:image")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col min-h-screen ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                        className: "flex-grow",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Templates_Details_TemplatesDetails__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            user_details: user_details,
                            tenant_details: tenant_details,
                            template_details: template_details
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_TradlyFooter__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (TemplateDetails);


/***/ }),

/***/ 55737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useGetPlansQuery; }
/* harmony export */ });
/* unused harmony export plansApi */
/* harmony import */ var _redux_api_TagTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26331);
/* harmony import */ var _redux_api_apiSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69356);


var plansApi = _redux_api_apiSlice__WEBPACK_IMPORTED_MODULE_1__/* .apiSlice.injectEndpoints */ .g.injectEndpoints({
    endpoints: function(builder) {
        return {
            //Get   Plans
            getPlans: builder.query({
                query: function() {
                    return "/v2/plans";
                },
                transformResponse: function(response, meta, arg) {
                    var ref;
                    var subscribed_plan = response === null || response === void 0 ? void 0 : (ref = response.plans) === null || ref === void 0 ? void 0 : ref.find(function(p) {
                        return p.subscribed;
                    });
                    var ref1, ref2, ref3;
                    return {
                        plans: (ref1 = response === null || response === void 0 ? void 0 : response.plans) !== null && ref1 !== void 0 ? ref1 : [],
                        old_plan: (ref2 = response === null || response === void 0 ? void 0 : response.old_plan) !== null && ref2 !== void 0 ? ref2 : [],
                        subscribed_plan: subscribed_plan !== null && subscribed_plan !== void 0 ? subscribed_plan : {},
                        subscribed_plan_name: (ref3 = subscribed_plan === null || subscribed_plan === void 0 ? void 0 : subscribed_plan.name) !== null && ref3 !== void 0 ? ref3 : ""
                    };
                },
                providesTags: [
                    _redux_api_TagTypes__WEBPACK_IMPORTED_MODULE_0__/* .tagTypes.plans */ .U.plans
                ]
            })
        };
    }
});
var useGetPlansQuery = plansApi.useGetPlansQuery;


/***/ }),

/***/ 59155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _asyncToGenerator = (__webpack_require__(60932)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
var getUserDetails = (__webpack_require__(10107)/* .getUserDetails */ .M_);
var ref = __webpack_require__(9669), axios = ref.default;
var ref1 = __webpack_require__(60538), getAuthKey = ref1.getAuthKey, getSelectedTenantDetails = ref1.getSelectedTenantDetails;
module.exports = {
    user_details: function() {
        var _ref = _asyncToGenerator(function(onSuccess, onError) {
            return _tsGenerator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getUserDetails(getAuthKey()).then(function(res) {
                                return onSuccess(res === null || res === void 0 ? void 0 : res.user);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(onSuccess, onError) {
            return _ref.apply(this, arguments);
        };
    }(),
    tenant_details: function() {
        var _ref = _asyncToGenerator(function(onSuccess, onError) {
            return _tsGenerator(this, function(_state) {
                axios.get("/api/user_tenants_details", {
                    params: {
                        auth_key: getAuthKey()
                    }
                }).then(function(res) {
                    onSuccess(getSelectedTenantDetails(res.data.data.tenants));
                });
                return [
                    2
                ];
            });
        });
        return function(onSuccess, onError) {
            return _ref.apply(this, arguments);
        };
    }()
};


/***/ }),

/***/ 10781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Avatar = function(param) {
    var text = param.text, bg_color = param.bg_color;
    var ref, ref1;
    var colors = [
        "red",
        "orange",
        "yellow",
        "green",
        "blue",
        "purple",
        "pink",
        "black",
        "white",
        "gray", 
    ];
    var color_selected = ((ref = colors.filter(function(cl) {
        return cl.includes(text.toLowerCase());
    })) === null || ref === void 0 ? void 0 : ref.length) > 0 ? colors.filter(function(cl) {
        return cl.includes(text.toLowerCase());
    })[0] : ((ref1 = colors.filter(function(cl) {
        return cl.includes(text.slice(0, 1).toLowerCase());
    })) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? colors.filter(function(cl) {
        return cl.includes(text.slice(0, 1).toLowerCase());
    })[0] : colors[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: " h-10 w-10 flex items-center justify-center rounded-full p-2 text-white text-sm font-semibold ",
        style: {
            backgroundColor: color_selected
        },
        children: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [43430,46911,61509,9979,3726,17624,13037,87536,26281,91586,25675,19702,90585,63344,81735,91397,31078,6493,48777,87218,82495,74818,93952,20433,49774,92888,40179], function() { return __webpack_exec__(27554); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);